import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AdsBanner from '@/components/feature/AdsBanner';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import EcosystemSection from './components/EcosystemSection';
import CategoriesSection from './components/CategoriesSection';
import CultureSection from './components/CultureSection';
import FeaturedBusinessesSection from './components/FeaturedBusinessesSection';
import CTASection from './components/CTASection';

function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <section className="w-full px-4 md:px-8 lg:px-12 pt-10 md:pt-14">
          <AdsBanner pageKey="home" />
        </section>
        <StatsSection />
        <EcosystemSection />
        <CategoriesSection />
        <CultureSection />
        <FeaturedBusinessesSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default Home;